<template>
  <div style="padding: 10px">
    <v-row>
      <v-col
        cols="6"
        sm="6"
        md="4"
        lg="3"
        xl="2"
        v-for="(item, index) in overviewIcon"
        :key="'Overview' + index"
      >
        <cardmenus :cardData="item" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cardmenus from "./dashboard/cardsmenu.vue";
import imgSection from "@/assets/dashboard/card_section.png";
import imgPayment from "@/assets/dashboard/card_payment.png";
import imgAdvisees from "@/assets/dashboard/card_advisees.png";
import imgGradeInput from "@/assets/dashboard/card_grade_input.png";
import imgTeachingRecord from "@/assets/dashboard/card_teaching_record.png";
import imgTeachingEval from "@/assets/dashboard/card_teaching_eval.png";
import imgIcService from "@/assets/dashboard/card_ic_service.png";
import imgOpenSection from "@/assets/dashboard/card_open_section.png";
import imgActivitiesRecord from "@/assets/dashboard/card_activities_record.png";
import imgViewStudent from "@/assets/dashboard/card_view_student.png";

export default {
  components: {
    cardmenus,
  },
  data() {
    return {
      imgViewStudent,
      overviewIcon: [
        {
          icon: "mdi-ballot-outline",
          image: imgSection,
          toppic: "Section",
          detail: "Manage your sections and time slots.",
          url: "/section",
          sortA: 1,
        },
        {
          icon: "mdi-currency-usd",
          image: imgPayment,
          toppic: "Payment",
          detail: "View and track your extra teaching payment.",
          url: "/payment",
          sortA: 2,
        },
        {
          icon: "mdi-book-account",
          image: imgAdvisees,
          toppic: "My Advisees",
          detail: "Academic results and enrollment information of students",
          url: "/advisees",
          sortA: 3,
        },
        {
          icon: "mdi-book-edit-outline",
          image: imgGradeInput,
          toppic: "Grade Input",
          detail: "Enter students' scores and grades.",
          url: "https://ks.muic.io/ScoreByInstructor",
          sortA: 5,
        },
        {
          icon: "mdi-border-all",
          image: imgTeachingRecord,
          toppic: "Teaching record",
          detail:
            "(Extra & Part-time) You are only required to upload the log record for courses under extra teaching payment or if you are a part-time instructor",
          url: "https://newmy.muic.io/teaching",
          sortA: 6,
        },
        {
          icon: "mdi-book-check-outline",
          image: imgTeachingEval,
          toppic: "Teaching Evaluation",
          detail: "View your teaching evaluation scores",
          url: "https://ks.muic.io/QuestionnaireByInstructor",
          sortA: 7,
        },
        {
          icon: "mdi-alert-rhombus-outline",
          image: imgIcService,
          toppic: "IC SERVICE",
          detail:
            "please click the create ticket button to let us know how we can help you.",
          url: "https://newmy.muic.io/service",
          sortA: 8,
        },
        {
          icon: "mdi-school",
          image: imgOpenSection,
          toppic: "Open Section",
          detail: "List of open sections",
          url: "/",
          sortA: 8,
        },
        {
          icon: "mdi-file-upload-outline",
          image: imgActivitiesRecord,
          toppic: "Activities Record",
          detail:
            "ACAS Database is a system used to record and manage academic activity data, such as research, publications, conferences, and training.",
          url: "/request-academic-service",
          sortA: 5,
        },
      ],
    };
  },
  mounted() {
    this.setMenu();
  },
  methods: {
    setMenu() {
      if (this.$store.state.role.RulesUser.RolePdPCChair) {
        this.overviewIcon.push({
          icon: "mdi-account-search-outline",
          image: this.imgViewStudent,
          toppic: "View Student",
          detail: "Find student information",
          url: "/searchstudent",
          sortA: 4,
        });
      }
      this.overviewIcon.sort((a, b) => {
        return a.sortA - b.sortA;
      });
    },
  },
};
</script>
